import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CreateOrPutRevenueTypeInput, RevenueType } from '@thro-types/billing';

import { AxiosRequestConfig } from 'axios';

import {
  createRevenueType,
  getRevenueTypes,
  UpdateInterface,
  updateRevenueType
} from 'api/billingService';

export const useGetRevenueTypesQuery = (config?: AxiosRequestConfig) => {
  const queryKey = ['revenuetype', config ? JSON.stringify(config.params) : ''];
  return useQuery({
    queryKey,
    queryFn: () => {
      return getRevenueTypes(config);
    },
    placeholderData: keepPreviousData
  });
};

export const useRevenueTypesMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();

  const queryKey = ['revenuetype'];
  const creation = useMutation<RevenueType, Error, CreateOrPutRevenueTypeInput>({
    mutationFn: async args => {
      return await createRevenueType(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  const update = useMutation<RevenueType, Error, UpdateInterface<CreateOrPutRevenueTypeInput>>({
    mutationFn: async args => {
      return await updateRevenueType(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  return { creation, update } as const;
};
